module.exports = __webpack_public_path__ + "media/fonts/Oricons-0f5c5edb6842411571c0db9370570667.eot";